module.exports = __webpack_public_path__ + "img/containerRearRight.c1cdd1ee.svg";